import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["iconSrc"];
import CUIImage from '../CUIImage/CUIImage';
import { jsx as _jsx } from "react/jsx-runtime";
const CUICommunityIcon = _ref => {
  let {
      iconSrc
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(CUIImage, Object.assign({
    src: iconSrc
  }, rest));
};
export default CUICommunityIcon;